<script>
import Layout from "../../layouts/main";
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";

import simplebar from "simplebar-vue";

import {
  transactionsData,
  bitconinChart,
  ethereumChart,
  litecoinChart,
  simplePieChart,
  donutAnimateChart,
} from "./data";

/**
 * Crypto Dashboard Component
 */
export default {
  page: {
    title: "Crypto Dashboard",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: { Layout, PageHeader, simplebar },
  data() {
    return {
      transactionsData: transactionsData,
      bitconinChart: bitconinChart,
      ethereumChart: ethereumChart,
      litecoinChart: litecoinChart,
      simplePieChart: simplePieChart,
      donutAnimateChart: donutAnimateChart,
      title: "Bulk SMS",
      items: [
        {
          text: "Dashboards",
          href: "/",
        },
        {
          text: "Bulk SMS",
          active: true,
        },
      ],
    };
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-xl-4">
        <div class="card">
          <div class="card-body border-top">
            <div class="row">
              <div class="col-lg-5 col-sm-5 align-self-center">
                <div>
                  <img
                    src="@/assets/images/crypto/features-img/img-1.png"
                    alt
                    class="img-fluid d-block"
                  />
                </div>
              </div>
              <div class="col-sm-6">
                <div>
                  <h5 class="fw-large mb-2">SMS Balance :</h5>
                  <h2 class="text-primary">6134.39</h2>
                </div>
              </div>
            </div>
          </div>

          <div class="card-footer bg-transparent border-top">
            <div class="col-md-12">
              <a
                href="javascript: void(0);"
                class="btn btn-sm btn-primary me-2 w-md"
                >Deposit / Subscribe</a
              >
              <a
                href="javascript: void(0);"
                class="btn btn-sm btn-secondary me-2 w-md float-end"
                ><i class="bx bxs-cog align-middle me-1"></i> Logs</a
              >
            </div>
          </div>
        </div>
      </div>

      <div class="col-xl-8">
        <div class="row">
          <div class="col-sm-4">
            <router-link :to="`/bulk-sms/fees-sms`">
              <div class="card">
                <div class="card-body">
                  <div class="d-flex align-items-center mb-3">
                    <div class="avatar-xs me-3">
                      <span
                        class="
                          avatar-title
                          rounded-circle
                          bg-soft bg-primary
                          text-primary
                          font-size-18
                        "
                      >
                        <i class="bx bx-copy-alt"></i>
                      </span>
                    </div>
                    <h5 class="font-size-14 mb-0">Fees SMS</h5>
                  </div>
                  <div class="text-muted mt-4 ml-2">
                    <h4 class="ml-2">
                      1,452
                      <!-- <i class="mdi mdi-chevron-up ms-1 text-success"></i> -->
                    </h4>
                    <div>
                      <!-- <span class="badge badge-soft-success font-size-12"
                      >+ 0.2%</span
                    > -->
                      <span class="ms-2 text-truncate"
                        >From previous Subcription</span
                      >
                    </div>
                  </div>
                </div>
              </div>
            </router-link>
          </div>

          <div class="col-sm-4">
            <router-link :to="`/bulk-sms/marks-sms`">
              <div class="card">
                <div class="card-body">
                  <div class="d-flex align-items-center mb-3">
                    <div class="avatar-xs me-3">
                      <span
                        class="
                          avatar-title
                          rounded-circle
                          bg-soft bg-primary
                          text-primary
                          font-size-18
                        "
                      >
                        <i class="bx bx-archive-in"></i>
                      </span>
                    </div>
                    <h5 class="font-size-14 mb-0">Marks SMS</h5>
                  </div>
                  <div class="text-muted mt-4">
                    <h4>28,452</h4>
                    <div class="d-flex">
                      <span class="ms-2 text-truncate"
                        >From Previous Subscription</span
                      >
                    </div>
                  </div>
                </div>
              </div>
            </router-link>
          </div>

          <div class="col-sm-4">
            <router-link :to="`/bulk-sms/custom-sms`">
              <div class="card">
                <div class="card-body">
                  <div class="d-flex align-items-center mb-3">
                    <div class="avatar-xs me-3">
                      <span
                        class="
                          avatar-title
                          rounded-circle
                          bg-soft bg-primary
                          text-primary
                          font-size-18
                        "
                      >
                        <i class="bx bx-purchase-tag-alt"></i>
                      </span>
                    </div>
                    <h5 class="font-size-14 mb-0">Others / Custom SMS</h5>
                  </div>
                  <div class="text-muted mt-4">
                    <h4>16.2</h4>

                    <div class="d-flex">
                      <span class="ms-2 text-truncate"
                        >From Previous Subscription</span
                      >
                    </div>
                  </div>
                </div>
              </div>
            </router-link>
          </div>
        </div>
        <!-- end row -->
      </div>
    </div>
    <!-- end row -->
    <div class="row">
      <div class="col-lg-6">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title mb-4">SMS Category</h4>
            <chartist
              ratio="ct-chart"
              :data="simplePieChart.data"
              :options="simplePieChart.options"
              type="Pie"
            ></chartist>
            <div class="row">
              <div class="col-4">
                <div class="mt-4">
                  <p class="mb-2 text-truncate">
                    <i class="mdi mdi-circle text-primary me-1"></i>
                    Fees SMS
                  </p>
                  <h5>2,132</h5>
                </div>
              </div>
              <div class="col-4">
                <div class="mt-4">
                  <p class="mb-2 text-truncate">
                    <i class="mdi mdi-circle text-success me-1"></i>
                    Marks SMS
                  </p>
                  <h5>1,763</h5>
                </div>
              </div>
              <div class="col-4">
                <div class="mt-4">
                  <p class="mb-2 text-truncate">
                    <i class="mdi mdi-circle text-danger me-1"></i>
                    Others / Custom SMS
                  </p>
                  <h5>973</h5>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-xl-6">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title mb-4">SMS Transactions Per Class</h4>
            <b-tabs pills nav-class="bg-light rounded" content-class="mt-4">
              <b-tab title="All SMS Categories" active>
                <b-card-text>
                  <simplebar style="max-height: 330px">
                    <table
                      class="table table-centered table-nowrap align-middle"
                    >
                      <tbody>
                        <tr v-for="data of transactionsData" :key="data.icon">
                          <!-- <td style="width: 50px">
                            <div :class="`font-size-22 text-${data.color}`">
                              <i
                                :class="{
                                  'bx bx-down-arrow-circle':
                                    `${data.color}` === 'primary',
                                  'bx bx-up-arrow-circle':
                                    `${data.color}` === 'danger',
                                }"
                              ></i>
                            </div>
                          </td> -->
                          <td>
                            <div>
                              <h5 class="font-size-14 mb-1">{{ data.name }}</h5>
                              <p class="text-muted mb-0">{{ data.date }}</p>
                            </div>
                          </td>
                          <!-- <td>
                            <div class="text-end">
                              <h5 class="font-size-14 mb-0">{{ data.text }}</h5>
                            </div>
                          </td> -->
                          <td>
                            <!-- <div class="text-end">
                              <h5 class="font-size-14 text-muted mb-0">
                                {{ data.price }}
                              </h5>
                            </div> -->
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </simplebar>
                </b-card-text>
              </b-tab>
              <b-tab title="Fees SMS">
                <b-card-text>
                  <simplebar style="max-height: 330px">
                    <table
                      class="table table-centered table-nowrap align-middle"
                    >
                      <tbody>
                        <tr v-for="data of transactionsData" :key="data.id">
                          <td>
                            <div>
                              <h5 class="font-size-14 mb-1">{{ data.name }}</h5>
                              <p class="text-muted mb-0">{{ data.date }}</p>
                            </div>
                          </td>
                          <td>
                            <!-- <div class="text-end">
                              <h5 class="font-size-14 text-muted mb-0">
                                {{ data.price }}
                              </h5>
                            </div> -->
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </simplebar>
                </b-card-text>
              </b-tab>
              <b-tab title="Marks SMS">
                <b-card-text>
                  <simplebar style="max-height: 330px">
                    <table
                      class="table table-centered table-nowrap align-middle"
                    >
                      <tbody>
                        <tr v-for="data of transactionsData" :key="data.id">
                          <td>
                            <div>
                              <h5 class="font-size-14 mb-1">{{ data.name }}</h5>
                              <p class="text-muted mb-0">{{ data.date }}</p>
                            </div>
                          </td>
                          <td>
                            <!-- <div class="text-end">
                              <h5 class="font-size-14 text-muted mb-0">
                                {{ data.price }}
                              </h5>
                            </div> -->
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </simplebar>
                </b-card-text>
              </b-tab>
            </b-tabs>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>
